module.exports = __webpack_public_path__ + "static/media/stars.513f5055.png";